















































































































import {
  ref,
  defineComponent,
  reactive,
  getCurrentInstance,
  ComponentInternalInstance,
  PropType,
} from '@vue/composition-api';

import { UsergroupIcon, DeleteIcon, UserIcon, ErrorCircleIcon } from 'tdesign-icons-vue';
import i18n, { i18n_t } from '@/locales/i18n';
import { phoneCompose } from '@/renderer/scripts/utils/tools/index';
import { SMH } from '@/renderer/scripts/smh';
import { checkRoleIsAdmin } from '@/renderer/scripts/utils/UserRole';
import { showPhoneOrAccountName } from '@/renderer/components/dialog/AddTransfer/compositions/useTools';

export interface BaseTableRef {
  selectedUids: string[];
  removeSelected: () => void;
}

export default defineComponent({
  name: 'BaseTable',
  components: {
    UsergroupIcon,
    DeleteIcon,
    UserIcon,
    ErrorCircleIcon,
  },
  props: {
    data: {
      type: Array as PropType<CoFile.TeamOrMemberItem[]>,
      default: [],
    },
    roleLoading: {
      type: Boolean,
      default: false,
    },
    roleOptions: {
      required: false,
      type: Array as PropType<SMH.Role[]>,
    },
    loading: {
      required: true,
      type: Boolean,
    },
    asyncLoading: {
      required: false,
      type: String,
      default: '',
    },
    // 是否允许管理员设置权限
    canAdminSetRole: {
      type: Boolean,
      default: false,
    },
    // checkAll: {
    //   type: Object,
    //   default: () => {
    //     return {
    //       checked: false,
    //       t: 0,
    //     };
    //   },
    // },
  },
  setup(props, { emit }) {
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const store = vm.$store;

    const columns = [
      {
        colKey: 'row-select',
        type: 'multiple',
        width: 21,
        disabled: ({ row }: { row: any }) => row.disabledOperate,
      },
      {
        colKey: 'name',
        title: i18n_t('姓名'),
        className: 'col-project-name',
      },
      {
        colKey: 'action',
        title: i18n_t('操作'),
        className: 'col-project-name',
      },
    ];

    const selectedUids = ref<string[]>([]);

    const methods = {
      removeSelected() {
        selectedUids.value = [];
      },
      onRemoveMember(index: number, item: CoFile.TeamOrMemberItem) {
        emit('remove', index, item);
      },
      onRoleChange(roleId: number, item: CoFile.TeamOrMemberItem) {
        emit('roleChange', roleId, item.uid);
      },
      onSelectChange(uids: string[], { selectedRowData }: { selectedRowData: CoFile.TeamOrMemberItem[] }) {
        selectedUids.value = uids;
        emit('selectChange', uids, selectedRowData);
      },
      onAsyncLoadingClick() {
        emit('loadMoreClick');
      },
      isAdmin(role: string, adminPermission: boolean, userId: string) {
        // 当在团队管理员的界面时，更新团队管理员的界面团队管理员肯定时有权限的
        const routeName = vm.$route.name as string;
        const admin = checkRoleIsAdmin(role, routeName !== 'teamManagement');
        const notMySelfAndHasPermission = adminPermission && userId !== store.getters.userId;
        return admin || notMySelfAndHasPermission;
      },
    };

    // TODO: 后续允许选中全部成员时再放出来
    // watch(
    //   () => props.checkAll,
    //   val => {
    //     tableData.selectedRowKeys = [];
    //     tableData.selectedList = [];
    //     const selectedAuthList: number[] = [];
    //     props.data.forEach((item: any) => {
    //       if (val.checked && !item.disabledOperate) {
    //         tableData.selectedRowKeys.push(item.uid);
    //         tableData.selectedList.push(item);
    //         selectedAuthList.push(item.uid);
    //       }
    //     });
    //     emit('selectChanged', selectedAuthList);
    //   },
    // );

    return {
      phoneCompose,
      columns,
      selectedUids,
      ...methods,
      checkRoleIsAdmin,
      showPhoneOrAccountName,
    };
  },
});
